import { EVENT_COMPARISON_LIST, EVENT_COMPARISON_LIST_SUCCESS, EVENT_COMPARISON_LIST_ERROR } from './constants';
import { EVENT_COMPARISON_DETAILS, EVENT_COMPARISON_DETAILS_SUCCESS, EVENT_COMPARISON_DETAILS_ERROR } from './constants';
import { ADD_EVENT_COMPARISON_DETAILS, ADD_EVENT_COMPARISON_DETAILS_SUCCESS, ADD_EVENT_COMPARISON_DETAILS_ERROR } from './constants';
import { UPDATE_EVENT_COMPARISON, UPDATE_EVENT_COMPARISON_SUCCESS, UPDATE_EVENT_COMPARISON_ERROR } from './constants';
import { DELETE_EVENT_COMPARISON, DELETE_EVENT_COMPARISON_SUCCESS, DELETE_EVENT_COMPARISON_ERROR } from './constants';

export default function EventComparisonReducer(state, action) {
	let eventComparisons = [];

	switch (action.type) {
	case EVENT_COMPARISON_LIST:
		return { ...state, pending: true };
      
	case EVENT_COMPARISON_LIST_SUCCESS:
        
		if (action.payload && action.payload.length > 0) {		
			action.payload.map( (item) => {
            
				let data = {};

				data.id = item.id ? item.id : 0;
				data.name = item.name ? item.name : '';
				data.channelId = item.channelId ? item.channelId : '';
				data.pidsinfoId = item.pidsinfoId ? item.pidsinfoId : 0;
				data.isSynced = item.isSynced ? item.isSynced : false;
				data.createdAt = item.createdAt ? item.createdAt : '';
				data.updatedAt = item.updatedAt ? item.updatedAt : '';

				return eventComparisons.push(data);
			});
          
			return { ...state, eventComparisons: eventComparisons, pending: false, error: false };
		} else {
			if (action.payload && action.payload.length === 0) {
				return { ...state, eventComparisons: eventComparisons, pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}
      
	case EVENT_COMPARISON_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case EVENT_COMPARISON_DETAILS:
		return { ...state, pending: true };

	case EVENT_COMPARISON_DETAILS_SUCCESS:
		return { ...state, details: action.payload, pending: false, error: false };

	case EVENT_COMPARISON_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case ADD_EVENT_COMPARISON_DETAILS:
		return { ...state, pending: false };

	case ADD_EVENT_COMPARISON_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case ADD_EVENT_COMPARISON_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case UPDATE_EVENT_COMPARISON:
		return { ...state, pending: false };

	case UPDATE_EVENT_COMPARISON_SUCCESS:
		return { ...state, pending: false, error: false };

	case UPDATE_EVENT_COMPARISON_ERROR:
		return { ...state, pending: false, error: true };
      
	case DELETE_EVENT_COMPARISON:
		return { ...state, pending: false };

	case DELETE_EVENT_COMPARISON_SUCCESS:
		return { ...state, pending: false, error: false };

	case DELETE_EVENT_COMPARISON_ERROR:
		return { ...state, pending: false, error: true };

	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}